<template>
  <div class="search-panel">
    <!-- <periodicTable></periodicTable> -->
    <el-row>
    <el-col :span="16">
    <el-checkbox v-model="exactMatch" label="exact match"></el-checkbox>
    <el-input v-model="elements_text" type="text" placeholder="input Elements:example:Ag,C"></el-input>
    <PTable :value="elems" @input="clickevent0"></PTable>
    <el-input v-model="formula_text" type="text" placeholder="input Formula:example:MoS2"></el-input>
    </el-col>
    <el-col :span="8">
    <rangeslider :valuename="'Gap range'" :minvalue="0" :maxvalue="12" :valuestep="0.01" v-model="gaprange"></rangeslider>
    <rangeslider :valuename="'Energy range'" :minvalue="-20" :maxvalue="10" :valuestep="0.01" v-model="energyrange"></rangeslider>
    <rangeslider :valuename="'unit cell sites'" :minvalue="0" :maxvalue="500" :valuestep="1" v-model="unitcellsites"></rangeslider>
    <rangeslider :valuename="'Space group'" :minvalue="1" :maxvalue="230" :valuestep="1" v-model="spacegrouprange"></rangeslider>
    <!--unit cell volume-->
    <rangeslider :valuename="'unit cell volume'" :minvalue="0" :maxvalue="100000" :valuestep="1" v-model="unitcellvolumerange"></rangeslider>
    <el-input v-model="tags_text" type="text" placeholder="input Tags:example:nonpbc"></el-input>
    </el-col>
    </el-row>
    <!-- <el-button @click="updatesearchkey()">搜索</el-button>
    <p>
      {{ searchkey }}
    </p> -->
  </div>
</template>

<script>
import PTable from './subcomponents/PTable.vue'
import rangeslider from './subcomponents/rangeslider.vue'
var allelements = [
  'H', 'He',
  'Li', 'Be', 'B', 'C', 'N', 'O', 'F', 'Ne',
  'Na', 'Mg', 'Al', 'Si', 'P', 'S', 'Cl', 'Ar',
  'K', 'Ca', 'Sc', 'Ti', 'V', 'Cr', 'Mn', 'Fe', 'Co', 'Ni', 'Cu', 'Zn', 'Ga', 'Ge', 'As', 'Se', 'Br', 'Kr',
  'Rb', 'Sr', 'Y', 'Zr', 'Nb', 'Mo', 'Tc', 'Ru', 'Rh', 'Pd', 'Ag', 'Cd', 'In', 'Sn', 'Sb', 'Te', 'I', 'Xe',
  'Cs', 'Ba',
  'La', 'Ce', 'Pr', 'Nd', 'Pm', 'Sm', 'Eu', 'Gd', 'Tb', 'Dy', 'Ho', 'Er', 'Tm', 'Yb', 'Lu',
  'Hf', 'Ta', 'W', 'Re', 'Os', 'Ir', 'Pt', 'Au', 'Hg', 'Tl', 'Pb', 'Bi', 'Po', 'At', 'Rn',
  'Fr', 'Ra',
  'Ac', 'Th', 'Pa', 'U', 'Np', 'Pu', 'Am', 'Cm', 'Bk', 'Cf', 'Es', 'Fm', 'Md', 'No', 'Lr',
  'Rf', 'Db', 'Sg', 'Bh', 'Hs', 'Mt', 'Ds', 'Rg', 'Cn'
]
export default {
  components: { PTable, rangeslider },
  name: 'searchpanel',
  props: {
    value: Object
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      elems: [],
      gaprange: [0, 12],
      energyrange: [-20, 10],
      unitcellsites: [0, 500],
      spacegrouprange: [1, 230],
      unitcellvolumerange: [0, 100000],
      formula_text: '',
      tags_text: '',
      searchkey: '',
      exactMatch: false
    }
  },
  methods: {
    clickevent0 (index) {
      console.log(this.mysearchkey)
    },
    updatesearchkey () {
      var newsearchkey = {}
      if (this.gaprange[0] !== 0 || this.gaprange[1] !== 12) {
        newsearchkey['property.gap'] = {'$gt': this.gaprange[0], '$lt': this.gaprange[1]}
      }
      if (this.energyrange[0] !== -20 || this.energyrange[1] !== 10) {
        newsearchkey['property.energyPerAtom'] = {'$gt': this.energyrange[0], '$lt': this.energyrange[1]}
      }
      if (this.unitcellsites[0] !== 0 || this.unitcellsites[1] !== 500) {
        newsearchkey['property.numberOfAtoms'] = {'$gt': this.unitcellsites[0], '$lt': this.unitcellsites[1]}
      }
      if (this.spacegrouprange[0] !== 1 || this.spacegrouprange[1] !== 230) {
        newsearchkey['property.spaceGroup'] = {'$gt': this.spacegrouprange[0], '$lt': this.spacegrouprange[1]}
      }
      if (this.unitcellvolumerange[0] !== 0 || this.unitcellvolumerange[1] !== 100000) {
        newsearchkey['property.unitCellVolume'] = {'$gt': this.unitcellvolumerange[0], '$lt': this.unitcellvolumerange[1]}
      }
      if (this.tags_text.trim() !== '') {
        newsearchkey['tags'] = {'$in': this.tags_text.split(',')}
      }
      if (this.formula_text.trim() !== '') {
        newsearchkey['formula'] = this.formula_text.trim()
      }
      for (var elemsi of this.elems) {
        newsearchkey['elements.' + elemsi] = {'$gt': 0}
      }
      if (this.exactMatch) {
        for (elemsi of allelements) {
          // elemsi exsits in this.elems
          if (this.elems.indexOf(elemsi) !== -1) {
            continue
          }
          newsearchkey['elements.' + elemsi] = {'$exists': false}
        }
      }
      this.searchkey = newsearchkey
    }
  },
  computed: {
    elements_text: {
      get: function () {
        return this.elems.join(',')
      },
      set: function (newValue) {
        this.elems = newValue.split(',')
        // console.log(this.elems)
      }
    },
    mysearchkey: {
      get: function () {
        this.updatesearchkey()
        return JSON.stringify(this.searchkey)
      },
      set: function (newValue) {
        this.searchkey = newValue
      }
    }
  },
  watch: {
    mysearchkey: function (newValue) {
      console.log(newValue)
      this.$emit('input', newValue)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/searchpanel.vue